<template>
  <a-modal
    wrapClassName="subscribe-retain-pop important-popup"
    width="auto"
    :footer="null"
    :maskClosable="false"
    centered
    v-model:open="show"
    :afterClose="onClose"
  >
    <template #closeIcon>
      <icon-font name="icon-guanbi" size="16" color="#3C3C43" />
    </template>
    <div class="retain-wrap">
      <div class="title">您的订阅已取消</div>
      <div class="card-warp">
        <div class="desc">
          <div>在当前周期结束前，</div>
          <div>您的所有创作都将为您安全保留，让每一个灵感都值得被记录！</div>
        </div>

        <img src="@/assets/images/retain/subscribe-card.png" class="card-img" />

        <div class="highlight">选择再次订阅，让 Holopix 继续陪伴您，点亮更多精彩瞬间。</div>
      </div>

      <a-button type="primary" class="card-button" :onclick="onConfirm">再次订阅</a-button>
    </div>
  </a-modal>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

interface Props {
  onClose: () => void;
}

defineProps<Props>();
const router = useRouter();
const show = ref(false);

onMounted(() => {
  show.value = true;
});

const onConfirm = () => {
  show.value = false;
  router.push({ name: "power" });
};

const modalId = "subscribe-retain-pop";
defineOptions({ modalId });
</script>

<style lang="less">
.subscribe-retain-pop {
  .ant-modal-content {
    width: 460px;
    height: 600px;
    border-radius: 38.4px;
    border: 1.6px solid rgba(235, 235, 245, 0.08);
    background: linear-gradient(249deg, #ffe6c0 0%, #fffbe9 100%);
    padding: 24px;
    padding-top: 32px;
  }
}
</style>

<style lang="less" scoped>
.retain-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  .title {
    font-weight: 900;
    font-size: 24px; /* Figma style_PQ8DVF */
    line-height: 1.17;
    color: #252728;
  }

  .card-warp {
    width: 100%;
    display: flex;
    gap: 24px;
    flex-direction: column;
    .desc {
      color: #000;
      font-size: 14px;
      font-weight: 400;
    }
    .highlight {
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
    }

    .card {
      width: 100%;
      height: 276px;
    }
  }
  .card-button {
    width: 100%;
    height: 52px; /* layout_SG5JKY */
    border: none;
    border-radius: 24px; /* borderRadius: 24px */
    background: linear-gradient(90deg, rgba(255, 64, 2, 1) 0%, rgba(255, 143, 23, 1) 100%); /* fill_R0630Q */
    font-weight: 900; /* style_5K5MTC */
    font-size: 18px;
    letter-spacing: 0.045em;
    color: #fff;

    &:hover,
    &::focus {
      opacity: 0.95;
    }
  }
}
</style>
